"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postFile = exports.del = exports.put = exports.post = exports.patch = exports.get = exports.setParams = exports.getHeaders = void 0;
var localstorage_1 = require("@klw/localstorage");
var localstorage_2 = require("@klw/localstorage");
var httpErrors_1 = require("./httpErrors");
function getHeaders() {
    var defaultHeaders = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localstorage_2.default.get(localstorage_1.DEFAULT_STORAGE_NAMES.TOKEN),
    };
    return __assign({}, defaultHeaders);
}
exports.getHeaders = getHeaders;
var setParams = function (route, params) {
    var list = [];
    Object.keys(params).forEach(function (key) {
        if (params[key]) {
            list.push(key + "=" + params[key]);
        }
    });
    if (list.length > 0) {
        return route + "?" + list.join("&");
    }
    return route;
};
exports.setParams = setParams;
function get(path, init) {
    if (init === void 0) { init = {}; }
    var options = __assign(__assign({ headers: getHeaders() }, init), { method: "GET" });
    return fetch(path, options).then(httpErrors_1.normalizeResponse).catch(httpErrors_1.catchResponse);
}
exports.get = get;
function patch(path, body, init) {
    if (body === void 0) { body = {}; }
    if (init === void 0) { init = {}; }
    var options = __assign(__assign({ headers: getHeaders() }, init), { method: "PATCH", body: JSON.stringify(body) });
    return fetch(path, options).then(httpErrors_1.normalizeResponse).catch(httpErrors_1.catchResponse);
}
exports.patch = patch;
function post(path, body, init) {
    if (body === void 0) { body = {}; }
    if (init === void 0) { init = {}; }
    var options = __assign(__assign({ headers: getHeaders() }, init), { method: "POST", body: JSON.stringify(body) });
    return fetch(path, options).then(httpErrors_1.normalizeResponse).catch(httpErrors_1.catchResponse);
}
exports.post = post;
function put(path, body, init) {
    if (body === void 0) { body = {}; }
    if (init === void 0) { init = {}; }
    var options = __assign(__assign({ headers: getHeaders() }, init), { method: "PUT", body: JSON.stringify(body) });
    return fetch(path, options).then(httpErrors_1.normalizeResponse).catch(httpErrors_1.catchResponse);
}
exports.put = put;
function del(path, body, init) {
    if (body === void 0) { body = {}; }
    if (init === void 0) { init = {}; }
    var options = __assign(__assign({ headers: getHeaders() }, init), { method: "DELETE", body: JSON.stringify(body) });
    return fetch(path, options).then(httpErrors_1.normalizeResponse).catch(httpErrors_1.catchResponse);
}
exports.del = del;
function postFile(url, file, options) {
    var onModifyProgress = function (event) {
        if (event.type === "progress" && (options === null || options === void 0 ? void 0 : options.onProgress)) {
            options.onProgress((event.loaded * 100) / event.total);
        }
    };
    return new Promise(function (resolve) {
        var formData = new FormData();
        formData.append("file", file);
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        xhr.setRequestHeader("Authorization", "Bearer " + localstorage_2.default.get(localstorage_1.DEFAULT_STORAGE_NAMES.TOKEN));
        // Add error resolver
        xhr.onerror = function (error) {
            resolve({ ok: false, error: error });
        };
        // Add success resolver
        xhr.onload = function () {
            resolve({ ok: true });
        };
        // Add onProgress callback
        if (xhr.upload && (options === null || options === void 0 ? void 0 : options.onProgress))
            xhr.upload.onprogress = onModifyProgress;
        xhr.send(formData);
    });
}
exports.postFile = postFile;
